import React, { Component } from 'react';
import { Field } from 'redux-form';
import { connect } from 'react-redux';

import { fetchDropdown } from '../../../actions/actionCreators';

import {
  renderSearchMultipleDropdown,
  renderSearchDropDown,
} from '../../common/form/FieldHelper';

class CustomFieldDropdown extends Component {
  render() {
    const {
      name,
      form,
      searchFn,
      onPostChange,
      multiple,
      preload = true,
    } = this.props;

    return (
      <div className="field">
        <Field
          {...this.props}
          name={name}
          formId={form}
          searchFn={searchFn}
          dropdownType="custom_field"
          type="custom_field"
          valueField="id"
          component={
            multiple ? renderSearchMultipleDropdown : renderSearchDropDown
          }
          onPostChange={onPostChange}
          preload={preload}
        />
      </div>
    );
  }
}

export default connect(
  null,
  { searchFn: fetchDropdown },
)(CustomFieldDropdown);
